import { DOM_NEW_SITE_REDIRECT_ROUTES, DOM_NEW_SITE_URL } from './dom-new-site-redirect.constants';
import { IsDomNewSiteCityAllowedArgs, ResolveDomNewSiteRegionIdArgs } from './dom-new-site-redirect.interfaces';

const REGION_ID_BY_STORE_ALIAS: ReadonlyMap<string, number> = buildStoreAliasMap();
const REGION_ID_BY_CITY_SLUG: ReadonlyMap<string, number> = buildCitySlugMap();

export function buildDomNewSiteRedirectUrl(regionId: number): string {
  return `${DOM_NEW_SITE_URL}/?region_id=${regionId}`;
}

export function isDomNewSiteCityAllowed(args: IsDomNewSiteCityAllowedArgs): boolean {
  const featureSet: ReadonlySet<string> = buildFeatureSet(args.featureCities);
  if (featureSet.size === 0) {
    return false;
  }

  const citySlug: string = normalizeKey(args.citySlug);
  if (citySlug && featureSet.has(citySlug)) {
    return true;
  }

  return getStoreKeys(args.storeKeys).some((key: string) => featureSet.has(key));
}

export function resolveDomNewSiteRegionId(args: ResolveDomNewSiteRegionIdArgs): number | null {
  for (const storeKey of getStoreKeys(args.storeKeys)) {
    const byStore: number | undefined = REGION_ID_BY_STORE_ALIAS.get(storeKey);
    if (byStore !== undefined) {
      return byStore;
    }
  }

  const citySlug: string = normalizeKey(args.citySlug);
  if (citySlug) {
    const byCity: number | undefined = REGION_ID_BY_CITY_SLUG.get(citySlug);
    if (byCity !== undefined) {
      return byCity;
    }
  }

  return null;
}

function getStoreKeys(storeKeys: readonly string[] | null | undefined): string[] {
  if (!storeKeys?.length) {
    return [];
  }

  const keys: string[] = [];

  for (const key of storeKeys) {
    const normalized: string = normalizeKey(key);
    if (normalized && !keys.includes(normalized)) {
      keys.push(normalized);
    }
  }

  return keys;
}

function buildFeatureSet(featureCities: readonly string[]): ReadonlySet<string> {
  const set: Set<string> = new Set<string>();

  for (const item of featureCities) {
    const key: string = normalizeKey(item);
    if (key) {
      set.add(key);
    }
  }

  return set;
}

function buildStoreAliasMap(): ReadonlyMap<string, number> {
  const map: Map<string, number> = new Map<string, number>();

  for (const route of DOM_NEW_SITE_REDIRECT_ROUTES) {
    for (const alias of route.storeAliases) {
      map.set(alias, route.regionId);
    }
  }

  return map;
}

function buildCitySlugMap(): ReadonlyMap<string, number> {
  const map: Map<string, number> = new Map<string, number>();

  for (const route of DOM_NEW_SITE_REDIRECT_ROUTES) {
    map.set(route.citySlug, route.regionId);
  }

  return map;
}

function normalizeKey(value: string | null | undefined): string {
  return typeof value === 'string' ? value.trim() : '';
}
